import request from '@/utils/request'

/** 誠實態：FIXED_PLAYBOOK ≠ Brand Agent 對話發現 */
export function fetchSmartGuideHonestyStatus () {
  return request({
    url: '/coffee/leo/soc-smart-guide/honesty-status',
    method: 'get'
  })
}

export function fetchSmartGuidePlaybooks (guideRole) {
  const params = {}
  if (guideRole) params.guideRole = guideRole
  return request({
    url: '/coffee/leo/soc-smart-guide/playbooks',
    method: 'get',
    params: params
  })
}

export function resolveSmartGuideIntent (payload) {
  return request({
    url: '/coffee/leo/soc-smart-guide/intent/resolve',
    method: 'post',
    data: payload || {}
  })
}

export function startSmartGuideSession (playbookId, opts) {
  const data = { playbookId: playbookId || 'store_manager_dispenser_r1' }
  if (opts && opts.storeId) data.storeId = opts.storeId
  if (opts && opts.entryStepId) data.entryStepId = opts.entryStepId
  if (opts && opts.pathHint) data.pathHint = opts.pathHint
  return request({
    url: '/coffee/leo/soc-smart-guide/sessions/start',
    method: 'post',
    data: data
  })
}

export function fetchSmartGuideCatalogGapReport (payload) {
  return request({
    url: '/coffee/leo/soc-smart-guide/catalog/gap-report',
    method: 'post',
    data: payload || {}
  })
}

export function fetchActiveSmartGuideSession () {
  return request({
    url: '/coffee/leo/soc-smart-guide/sessions/active',
    method: 'get'
  })
}

export function refreshSmartGuideSession (sessionId) {
  return request({
    url: '/coffee/leo/soc-smart-guide/sessions/' + sessionId + '/refresh',
    method: 'post'
  })
}

export function cancelSmartGuideSession (sessionId) {
  return request({
    url: '/coffee/leo/soc-smart-guide/sessions/' + sessionId + '/cancel',
    method: 'post'
  })
}

export function assistSmartGuideSession (sessionId, action) {
  return request({
    url: '/coffee/leo/soc-smart-guide/sessions/' + sessionId + '/assist',
    method: 'post',
    data: { action: action || 'refresh_check' }
  })
}



// WEBPACK FOOTER //
// ./src/api/socSmartGuide.js